import Vue from 'vue'
import App from './App.vue'
import router from './router'
import * as filters from '@/filters'

// 移动端适配 root font-size修改
import '@/assets/scripts/flexible.debug'
import '@/assets/scripts/flexible-css.debug'

import '@/assets/style/index.scss'
import '@/assets/text/text.css'

import Client from '@/assets/scripts/client'
import GlobalMixins from '@/assets/scripts/global-mixin'
import i18n from '@/lang'
import VueClipBoard from 'vue-clipboard2'
import TransformSpecialCodeComp from '@/components/TransformSpecialCode/index.vue'

import '@/utils/thinking-data.js'

// 测试环境用
import VConsole from 'vconsole'

import * as Sentry from '@sentry/vue'

import packageJson from '../package.json'

import {
  NavBar,
  Popover,
  Icon,
  Popup,
  DatetimePicker,
  Picker,
  NumberKeyboard,
  CountDown,
  Dialog,
  Progress,
  Uploader,
  Loading,
  NoticeBar,
  Tab,
  Tabs,
  List,
  Step,
  Steps,
  Swipe,
  SwipeItem,
  Overlay,
  Field,
  CellGroup,
  Stepper,
  Circle
} from 'vant'

Vue.component('MyPLabel', TransformSpecialCodeComp)

Vue.use(VueClipBoard)
Vue.use(NavBar)
Vue.use(Popover)
Vue.use(Icon)
Vue.use(Popup)
Vue.use(DatetimePicker)
Vue.use(Picker)
Vue.use(NumberKeyboard)
Vue.use(CountDown)
Vue.use(Dialog)
Vue.use(Progress)
Vue.use(Uploader)
Vue.use(Loading)
Vue.use(NoticeBar)
Vue.use(Tab)
Vue.use(Tabs)
Vue.use(List)
Vue.use(Step).use(Steps)
Vue.use(Swipe).use(SwipeItem)
Vue.use(Overlay)
Vue.use(Field)
Vue.use(CellGroup)
Vue.use(Stepper)
Vue.use(Circle)

// filters
Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key])
})

Vue.mixin(GlobalMixins)

Vue.config.productionTip = false

Vue.prototype.$client = Client

Vue.prototype.$sentry = Sentry

// 测试环境用
if (process.env.NODE_ENV === 'test') {
  new VConsole()
}

if (process.env.NODE_ENV === 'production') {
  try {
    Sentry.init({
      Vue,
      dsn: 'https://64e5bce043ce5ef0af2b3fa8683c39e7@sentry.goparty.tech/12',
      release: `${process.env.NODE_ENV}@${packageJson.version}`,
      sendDefaultPii: true,
      sampleRate: 0.8,
      environment: process.env.NODE_ENV
    })
  } catch (err) {
    console.log('try catch err:', err)
  }
}

new Vue({
  router,
  i18n,
  render: (h) => h(App)
}).$mount('#app')
